import axios from "axios";

const state = {
    endpoint: "/mail",
}

const getters = {

}

const actions = {
    async sendMail({ rootState }, mailData) {
        try {
            const token = await this._vm.$directus.auth.token;
            const url = rootState.app.mailerURL;
            const options = {
                withCredentials: true,
                headers: {
                    Authorization: "bearer " + token
                }
            }

            await axios.post(url, mailData, options);
        } catch (error) {
            console.log(error);
            throw "Error sending Mail.";
        }
    },
}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};